import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import GeneralNavbar from './GeneralNavbar';
import { useAuth } from './AuthContext';
import './ClientOrders.css';

const ClientOrders = () => {
  const { currentUser } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [numOrdersToShow, setNumOrdersToShow] = useState(1); // Estado para manejar el número de órdenes a mostrar
  const [hasMoreOrders, setHasMoreOrders] = useState(true); // Para saber si hay más órdenes que cargar
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/'); // Cambia esta ruta según dónde quieras que regrese el usuario
  };

  useEffect(() => {
    const fetchClientOrders = async () => {
      if (!currentUser) {
        console.error('Usuario no autenticado');
        return;
      }

      try {
        // Consultar las compras del usuario logueado, ordenadas por idTracker descendente, con límite dinámico
        const q = query(
          collection(db, 'compras'),
          where('userId', '==', currentUser.uid),
          orderBy('idTracker', 'desc'),
          limit(numOrdersToShow) // Limitar la consulta por el número de órdenes a mostrar
        );
        const querySnapshot = await getDocs(q);

        const clientOrders = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setOrders(clientOrders);

        // Si el número de resultados obtenidos es menor que el límite, no hay más órdenes
        if (querySnapshot.size < numOrdersToShow) {
          setHasMoreOrders(false);
        }
      } catch (error) {
        console.error('Error al obtener los pedidos del usuario:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClientOrders();
  }, [currentUser, numOrdersToShow]); // Actualizar cuando cambie el número de órdenes a mostrar

  const handleShowMore = () => {
    setNumOrdersToShow(prevNum => prevNum + 1); // Incrementa el límite en 5 más órdenes
  };

  if (loading) {
    return (
      <div>
        <GeneralNavbar title="Mis Pedidos" onBackClick={handleBackClick} />
        <p className="centered-text">Cargando...</p>
      </div>
    );
  }

  return (
    <div>
      <GeneralNavbar title="Mis Pedidos" onBackClick={handleBackClick} />

      <div className="client-orders-container">
        <h3>Mis Pedidos</h3>
        {orders.length === 0 ? (
          <p className="centered-text">No se encontraron pedidos para este usuario.</p>
        ) : (
          <div className="orders-cards">
            {orders.map(order => (
              <div className="order-card" key={order.id}>
                <h4>ID: {order.idTracker}</h4>
                <p><strong>Fecha:</strong> {new Date(order.timestamp.seconds * 1000).toLocaleString()}</p>
                <p>Total: ${(Number(order.totalPrice) || 0).toFixed(2)}</p>
                <p><strong>Estado:</strong> {order.status}</p>
                <p><strong>Método de Pago:</strong> {order.paymentMethod}</p>

                {/* Mostrar comprobante solo si el método de pago es "Mercado Pago" */}
                {order.paymentMethod === "Mercado Pago" && order.paymentId && (
                  <p><strong>Comprobante:</strong> {order.paymentId}</p>
                )}
                <Link to={`/CustomerPurchaseDetail/${order.id}`} className="details-link">Ver Detalles</Link>
              </div>
            ))}
          </div>
        )}

        {hasMoreOrders && orders.length > 0 && ( // Mostrar el botón solo si hay más órdenes para cargar
          <div className="centered-text">
            <button onClick={handleShowMore} className="load-more-button">
              Ver más
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientOrders;
